import service from '@/utils/request'

export function examList(data) {
  return service({
    url: '/api/exam/list',
    method: 'post',
    data
  })
}

export function examAdd(data) {
  return service({
    url: '/api/exam/add',
    method: 'post',
    data
  })
}

export function examEdit(data) {
  return service({
    url: '/api/exam/edit',
    method: 'post',
    data
  })
}

export function examDelete(data) {
  return service({
    url: '/api/exam/delete',
    method: 'post',
    data
  })
}